import { ApiCurrencySymbolKeys } from './enums';

const symbolMap: Record<string, ApiCurrencySymbolKeys> = {
  SEP: 'ETH',
  USDC: 'USDC',
  USDT: 'USDT',
  ETH: 'ETH',
  UTK: 'UTK',
  DASH: 'DASH',
  BTC: 'BTC',
  POL: 'POL',
};

export const currencySymbolToApiSymbol = (symbol: string) => {
  return symbolMap[symbol];
};
